import type { MarketType } from '@ps/isp-web-services-types';

export const oddsBoostMarkets = [
  'POWER_PRICES',
  'ODDS_BOOST',
  'DAILY_POWER_PRICES',
  'POWER_PRICE'
] as const satisfies readonly MarketType[];
